"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _menuContext = _interopRequireDefault(require("../context/menuContext"));
var _userMenuContext = _interopRequireDefault(require("../context/userMenuContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ChangePage = _ref => {
  let {
    history
  } = _ref;
  const setMenuOpen = (0, _react.useContext)(_menuContext.default)[1];
  const setUserMenuOpen = (0, _react.useContext)(_userMenuContext.default)[1];
  (0, _react.useEffect)(() => {
    const unlisten = history.listen(() => {
      setMenuOpen(false);
      setUserMenuOpen(false);
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  });
  return null;
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(ChangePage);